import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    processing,
    goalReached,
    pending,
    completed,
} from '../constants/pacingStatus';
import * as format from '../utils/formatters';
import classNames from '@app/ui/sports-components/utils/classNames';
import { getColorClass } from '../utils/pacingStatus';

const Status = ({
    statusId,
    targetValue,
    currentValue,
    hideValues = false,
}) => {
    const { t } = useTranslation('tools');
    if (!statusId) return null;
    const isReached = statusId === goalReached || statusId === completed;
    const circleClassName = classNames(
        'status_circle',
        '-m-r-2',
        '-inline-block',
        getColorClass(statusId),
    );

    const notYetStarted =
        statusId === processing ||
        statusId === pending ||
        !Number.isFinite(currentValue);

    return (
        <div className="-inline-block">
            {!isReached && <div className={circleClassName} />}
            {isReached && (
                <i className="fa fa-fw fa-check -m-r-2 -inline-block -color-tx-suc" />
            )}
            {!hideValues &&
                !notYetStarted &&
                `${format.decimal(currentValue)} (${format.percentage(
                    parseInt(currentValue) / parseInt(targetValue),
                    {
                        maximumFractionDigits: 0,
                    },
                )})`}
            {!hideValues &&
                notYetStarted &&
                statusId === processing &&
                t('pacing.status.processing')}
            {!hideValues &&
                notYetStarted &&
                statusId === pending &&
                t('pacing.status.pending')}
        </div>
    );
};

Status.propTypes = {
    statusId: PropTypes.number,
    targetValue: PropTypes.number,
    currentValue: PropTypes.number,
    hideValues: PropTypes.bool,
};

export default Status;
